// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2guq5","signatureBlock":"Footer_signatureBlock__2gyOf","signature":"Footer_signature__1WtnW"};